__turbopack_context__.v({
  "aboutLink": "roast-module__w8sAvq__aboutLink" + " " + "roast-module__w8sAvq__button" + " " + "roast-module__w8sAvq__buttonGhost" + " " + "roast-module__w8sAvq__buttonSmall",
  "accountFoot": "roast-module__w8sAvq__accountFoot",
  "accountMenuHead": "roast-module__w8sAvq__accountMenuHead",
  "accountMenuName": "roast-module__w8sAvq__accountMenuName",
  "actions": "roast-module__w8sAvq__actions",
  "actionsFill": "roast-module__w8sAvq__actionsFill",
  "archive": "roast-module__w8sAvq__archive",
  "archiveBody": "roast-module__w8sAvq__archiveBody",
  "archiveCover": "roast-module__w8sAvq__archiveCover",
  "archiveTile": "roast-module__w8sAvq__archiveTile" + " " + "roast-module__w8sAvq__card",
  "avatar": "roast-module__w8sAvq__avatar",
  "avatarBadge": "roast-module__w8sAvq__avatarBadge",
  "avatarButton": "roast-module__w8sAvq__avatarButton",
  "avatarMenuButton": "roast-module__w8sAvq__avatarMenuButton",
  "batchHead": "roast-module__w8sAvq__batchHead",
  "batchNav": "roast-module__w8sAvq__batchNav",
  "brand": "roast-module__w8sAvq__brand",
  "brandMark": "roast-module__w8sAvq__brandMark",
  "button": "roast-module__w8sAvq__button",
  "buttonBlock": "roast-module__w8sAvq__buttonBlock",
  "buttonGhost": "roast-module__w8sAvq__buttonGhost" + " " + "roast-module__w8sAvq__button",
  "buttonSmall": "roast-module__w8sAvq__buttonSmall",
  "card": "roast-module__w8sAvq__card",
  "center": "roast-module__w8sAvq__center",
  "chip": "roast-module__w8sAvq__chip",
  "chipExplained": "roast-module__w8sAvq__chipExplained" + " " + "roast-module__w8sAvq__chip",
  "chips": "roast-module__w8sAvq__chips",
  "countdown": "roast-module__w8sAvq__countdown",
  "countdownValue": "roast-module__w8sAvq__countdownValue",
  "crown": "roast-module__w8sAvq__crown",
  "cta": "roast-module__w8sAvq__cta",
  "ctaBody": "roast-module__w8sAvq__ctaBody",
  "ctaMark": "roast-module__w8sAvq__ctaMark",
  "dialog": "roast-module__w8sAvq__dialog",
  "dialogTitle": "roast-module__w8sAvq__dialogTitle",
  "drop": "roast-module__w8sAvq__drop",
  "dropIcon": "roast-module__w8sAvq__dropIcon",
  "empty": "roast-module__w8sAvq__empty",
  "error": "roast-module__w8sAvq__error",
  "eyebrow": "roast-module__w8sAvq__eyebrow",
  "fan": "roast-module__w8sAvq__fan",
  "fanPhoto": "roast-module__w8sAvq__fanPhoto",
  "feature": "roast-module__w8sAvq__feature" + " " + "roast-module__w8sAvq__card",
  "featureGrid": "roast-module__w8sAvq__featureGrid",
  "featureIcon": "roast-module__w8sAvq__featureIcon",
  "featureText": "roast-module__w8sAvq__featureText",
  "featureTitle": "roast-module__w8sAvq__featureTitle",
  "feedEnd": "roast-module__w8sAvq__feedEnd",
  "field": "roast-module__w8sAvq__field",
  "flame": "roast-module__w8sAvq__flame",
  "gallery": "roast-module__w8sAvq__gallery",
  "grid": "roast-module__w8sAvq__grid",
  "grow": "roast-module__w8sAvq__grow",
  "header": "roast-module__w8sAvq__header",
  "headerActions": "roast-module__w8sAvq__headerActions",
  "hero": "roast-module__w8sAvq__hero",
  "heroAccent": "roast-module__w8sAvq__heroAccent",
  "heroActions": "roast-module__w8sAvq__heroActions",
  "heroFacts": "roast-module__w8sAvq__heroFacts",
  "heroSignIn": "roast-module__w8sAvq__heroSignIn",
  "heroSplit": "roast-module__w8sAvq__heroSplit" + " " + "roast-module__w8sAvq__hero",
  "heroText": "roast-module__w8sAvq__heroText",
  "heroTitle": "roast-module__w8sAvq__heroTitle" + " " + "roast-module__w8sAvq__title",
  "iconButton": "roast-module__w8sAvq__iconButton",
  "input": "roast-module__w8sAvq__input",
  "judged": "roast-module__w8sAvq__judged",
  "judgedExpand": "roast-module__w8sAvq__judgedExpand",
  "judgedRow": "roast-module__w8sAvq__judgedRow",
  "keepCount": "roast-module__w8sAvq__keepCount",
  "keepHead": "roast-module__w8sAvq__keepHead",
  "keepMark": "roast-module__w8sAvq__keepMark",
  "keepVoice": "roast-module__w8sAvq__keepVoice",
  "label": "roast-module__w8sAvq__label",
  "landing": "roast-module__w8sAvq__landing",
  "landingSection": "roast-module__w8sAvq__landingSection",
  "landingText": "roast-module__w8sAvq__landingText",
  "landingTitle": "roast-module__w8sAvq__landingTitle",
  "link": "roast-module__w8sAvq__link",
  "linkButton": "roast-module__w8sAvq__linkButton",
  "list": "roast-module__w8sAvq__list",
  "main": "roast-module__w8sAvq__main",
  "meter": "roast-module__w8sAvq__meter",
  "meterHint": "roast-module__w8sAvq__meterHint",
  "moreLink": "roast-module__w8sAvq__moreLink",
  "muted": "roast-module__w8sAvq__muted",
  "myPhoto": "roast-module__w8sAvq__myPhoto",
  "myPhotoDelete": "roast-module__w8sAvq__myPhotoDelete" + " " + "roast-module__w8sAvq__iconButton",
  "nav": "roast-module__w8sAvq__nav",
  "navLink": "roast-module__w8sAvq__navLink",
  "noneOption": "roast-module__w8sAvq__noneOption",
  "noneRow": "roast-module__w8sAvq__noneRow",
  "notice": "roast-module__w8sAvq__notice" + " " + "roast-module__w8sAvq__card",
  "noticeText": "roast-module__w8sAvq__noticeText",
  "option": "roast-module__w8sAvq__option",
  "optionBar": "roast-module__w8sAvq__optionBar",
  "optionBody": "roast-module__w8sAvq__optionBody",
  "optionChoice": "roast-module__w8sAvq__optionChoice",
  "optionMark": "roast-module__w8sAvq__optionMark",
  "optionMeta": "roast-module__w8sAvq__optionMeta",
  "optionShare": "roast-module__w8sAvq__optionShare",
  "optionText": "roast-module__w8sAvq__optionText",
  "options": "roast-module__w8sAvq__options",
  "outcome": "roast-module__w8sAvq__outcome",
  "page": "roast-module__w8sAvq__page",
  "pageWide": "roast-module__w8sAvq__pageWide",
  "photo": "roast-module__w8sAvq__photo",
  "photoImage": "roast-module__w8sAvq__photoImage",
  "photoMeta": "roast-module__w8sAvq__photoMeta",
  "photoTitle": "roast-module__w8sAvq__photoTitle",
  "pill": "roast-module__w8sAvq__pill",
  "pop": "roast-module__w8sAvq__pop",
  "profile": "roast-module__w8sAvq__profile",
  "profileAvatar": "roast-module__w8sAvq__profileAvatar" + " " + "roast-module__w8sAvq__avatar",
  "profileName": "roast-module__w8sAvq__profileName",
  "progress": "roast-module__w8sAvq__progress",
  "progressLabel": "roast-module__w8sAvq__progressLabel",
  "progressStep": "roast-module__w8sAvq__progressStep",
  "pulse": "roast-module__w8sAvq__pulse",
  "rise": "roast-module__w8sAvq__rise",
  "root": "roast-module__w8sAvq__root" + " " + "roast-module__w8sAvq__tokens",
  "row": "roast-module__w8sAvq__row",
  "sectionIntroCenter": "roast-module__w8sAvq__sectionIntroCenter",
  "sectionIntroRow": "roast-module__w8sAvq__sectionIntroRow",
  "sectionTitle": "roast-module__w8sAvq__sectionTitle",
  "segment": "roast-module__w8sAvq__segment",
  "segments": "roast-module__w8sAvq__segments",
  "showcase": "roast-module__w8sAvq__showcase",
  "showcaseBack": "roast-module__w8sAvq__showcaseBack",
  "showcaseCard": "roast-module__w8sAvq__showcaseCard" + " " + "roast-module__w8sAvq__card",
  "showcaseTag": "roast-module__w8sAvq__showcaseTag",
  "signIn": "roast-module__w8sAvq__signIn" + " " + "roast-module__w8sAvq__card",
  "signInButton": "roast-module__w8sAvq__signInButton",
  "signOut": "roast-module__w8sAvq__signOut",
  "skeleton": "roast-module__w8sAvq__skeleton",
  "skeletonOption": "roast-module__w8sAvq__skeletonOption",
  "small": "roast-module__w8sAvq__small",
  "spin": "roast-module__w8sAvq__spin",
  "spinner": "roast-module__w8sAvq__spinner",
  "stack": "roast-module__w8sAvq__stack",
  "stat": "roast-module__w8sAvq__stat",
  "statLabel": "roast-module__w8sAvq__statLabel",
  "statValue": "roast-module__w8sAvq__statValue",
  "stats": "roast-module__w8sAvq__stats",
  "statsWide": "roast-module__w8sAvq__statsWide" + " " + "roast-module__w8sAvq__stats",
  "step": "roast-module__w8sAvq__step",
  "stepCard": "roast-module__w8sAvq__stepCard" + " " + "roast-module__w8sAvq__card",
  "stepDot": "roast-module__w8sAvq__stepDot",
  "stepGrid": "roast-module__w8sAvq__stepGrid",
  "stepHead": "roast-module__w8sAvq__stepHead",
  "stepNumber": "roast-module__w8sAvq__stepNumber",
  "stepText": "roast-module__w8sAvq__stepText",
  "stepTitle": "roast-module__w8sAvq__stepTitle",
  "stepVisual": "roast-module__w8sAvq__stepVisual",
  "steps": "roast-module__w8sAvq__steps",
  "subtitle": "roast-module__w8sAvq__subtitle",
  "summary": "roast-module__w8sAvq__summary" + " " + "roast-module__w8sAvq__card",
  "tab": "roast-module__w8sAvq__tab",
  "tabbar": "roast-module__w8sAvq__tabbar",
  "tag": "roast-module__w8sAvq__tag",
  "tapHint": "roast-module__w8sAvq__tapHint",
  "thumb": "roast-module__w8sAvq__thumb",
  "thumbBody": "roast-module__w8sAvq__thumbBody",
  "thumbCaption": "roast-module__w8sAvq__thumbCaption",
  "thumbRow": "roast-module__w8sAvq__thumbRow" + " " + "roast-module__w8sAvq__card",
  "tile": "roast-module__w8sAvq__tile",
  "tileCaption": "roast-module__w8sAvq__tileCaption",
  "tileMeta": "roast-module__w8sAvq__tileMeta",
  "tileRank": "roast-module__w8sAvq__tileRank",
  "tileShade": "roast-module__w8sAvq__tileShade",
  "title": "roast-module__w8sAvq__title",
  "titleRow": "roast-module__w8sAvq__titleRow",
  "toast": "roast-module__w8sAvq__toast",
  "toastHost": "roast-module__w8sAvq__toastHost",
  "tokens": "roast-module__w8sAvq__tokens",
  "unfolded": "roast-module__w8sAvq__unfolded",
  "verdict": "roast-module__w8sAvq__verdict",
  "verdictIcon": "roast-module__w8sAvq__verdictIcon",
  "voice": "roast-module__w8sAvq__voice",
  "voiceCard": "roast-module__w8sAvq__voiceCard" + " " + "roast-module__w8sAvq__card",
  "voiceFill": "roast-module__w8sAvq__voiceFill",
  "voiceGrid": "roast-module__w8sAvq__voiceGrid",
  "voiceHead": "roast-module__w8sAvq__voiceHead",
  "voiceName": "roast-module__w8sAvq__voiceName",
  "voiceNote": "roast-module__w8sAvq__voiceNote",
  "voiceNoteKind": "roast-module__w8sAvq__voiceNoteKind",
  "voiceNoteName": "roast-module__w8sAvq__voiceNoteName",
  "voiceQuote": "roast-module__w8sAvq__voiceQuote",
  "voiceTagline": "roast-module__w8sAvq__voiceTagline",
  "voiceTrack": "roast-module__w8sAvq__voiceTrack",
  "voices": "roast-module__w8sAvq__voices",
});
